// extracted by mini-css-extract-plugin
export default {"App":"Layout_App__YJpYB"};